// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-list-container,
.user-form-container {
  padding-top: 20px;
  padding-bottom: 40px;
}

.user-table th,
.user-table td {
  vertical-align: middle;
}

.card {
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

@media (max-width: 768px) {
  .user-list-container,
  .user-form-container {
    padding-top: 10px;
  }
  
  .user-table {
    font-size: 0.9rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/User/User.css"],"names":[],"mappings":"AAAA;;EAEE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;;IAEE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".user-list-container,\n.user-form-container {\n  padding-top: 20px;\n  padding-bottom: 40px;\n}\n\n.user-table th,\n.user-table td {\n  vertical-align: middle;\n}\n\n.card {\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n@media (max-width: 768px) {\n  .user-list-container,\n  .user-form-container {\n    padding-top: 10px;\n  }\n  \n  .user-table {\n    font-size: 0.9rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
